import type { RouteObject } from 'react-router';

import { ShelvesPage } from './Shelves';

/**
 * `/shelves`. One `RouteObject`, so the file is `.route.tsx` singular.
 *
 * It sits inside the console layout route, which already runs the guard chain —
 * `sessionInMemory? → silentRefreshOnceOn401 → me() → roleGate` — so this route
 * adds no loader of its own. The guard decides **navigation**; every read and
 * every write this page makes is authorized by `backend-content` on the request
 * itself, and the origin the call arrives from is never an authorization input.
 */
export const shelvesRoute: RouteObject = {
  path: 'shelves',
  element: <ShelvesPage />,
};
